// ファイル選択ボタン
import React from 'react';
var FileSelectButton = function (_a) {
    var label = _a.label, file_id = _a.file_id, handleFileSelect = _a.handleFileSelect, acceptType = _a.acceptType, is_loading = _a.is_loading, module_name = _a.module_name;
    var handleClickButton = function () {
        var element = document.getElementById(file_id);
        element === null || element === void 0 ? void 0 : element.click();
    };
    return (React.createElement("div", null,
        React.createElement("button", { className: "btn btn-main-color form-btn-size", onClick: handleClickButton, disabled: is_loading }, label),
        React.createElement("input", { type: "file", className: "file-upload", id: file_id, onChange: handleFileSelect, accept: acceptType, "data-module_name": module_name })));
};
export default FileSelectButton;
